import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const TrainingOnlineOffline = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="TrainingOnlineOffline" />
                    <HerosectionsAll ScreenName="Training Online Offline" ScreenSearch="Online" />

                    <div className="row p-2 px-lg-5 py-lg-5 col-lg-10 mx-auto my-5 ">
                        <div className="col-12 p-lg-5 p-4 faint" style={{textAlign: 'justify'}}>
                        <h5 className="fw-bold gray_color pb-3">Training Online Offline </h5>

                            <p>We are committed to continuous professional development (CPD). Training improves  a person's knowledge, skills, and attitude. Insurance is a rapidly developing and ever-changing industry. A CPD is required to keep up with evolving international trade norms, regulations, and conventions, as well as numerous changes to them. </p>
                            <p>We require competent professionals to increase capacity of the marine insurance Industry. For which we are organizing online and offline training programs to help people expand their knowledge, skill and attitudes. We use various tools and training methods for delivering the classroom sessions.</p>
                            <p> Every organisation that invests in employee training, expects a Return on Investment (ROI). We calculate ROI of training using Philips ROI technique, which helps us to satisfy our clients.</p>

                        </div>
                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
